import _ from 'lodash';
import angular from 'angular';
import {Loader} from "@googlemaps/js-api-loader"

import BaseAddModal from 'app/common/create.modal';
import {BaseReCalc} from 'app/common/calculation';

import {PrinterListModalCtrl} from 'app/printers/ctrls';

import printModalTpl from 'app/printers/modal.list.html';
import addTpl from 'app/common/create.modal.tpl.html';
import cloneTicketTpl from './templates/clone.ticket.html'
import sendBBTpl from './templates/sendbb.modal.html';
import copyMixTpl from './templates/copy.mix.html';
import ticketEditTpl from './templates/edit.modal.html';
import ticketConfirmEditTpl from './templates/confirm.edit.modal.html';
import ticketConfirmSendTpl from './templates/confirm.send.modal.html';
import confirmStopDeliveryTpl from './templates/confirm.stop.delivery.modal.html';
import confirmStopApplicationTpl from './templates/confirm.stop.application.modal.html';

import {DetailViewMap, EditViewMap} from '../helpers';
import {deliveryType, timerFields, timerType, ticketStatus} from "./constants";
import {MARION_ID} from '../constants';


export class FieldConf {
    constructor(ticket, prodConf) {
        this.ticket = ticket;
        delete this.ticket.delivery_start;
        delete this.ticket.delivery_stop;
        delete this.ticket.application_start;
        delete this.ticket.application_stop;
        this.prodConf = prodConf;

        this.fields = null;
        this.ui = null;
        this.values = null;
        this.products = null;
        this.fields = {
            top: _.range(8),
            bottom: _.range(10),
        };
        this.init();
    }

    hasUiPlace(config) {
        return !_.isUndefined(config.ui_row) && !_.isUndefined(config.ui_place);
    }

    init() {
        let self = this;
        this.ui = {
            top: _.chain(this.fields.top).map(x => [x, []]).fromPairs().value(),
            bottom: _.chain(this.fields.bottom).map(x => [x, []]).fromPairs().value(),
        };

        this.values = {
            top: _.chain(this.fields.top).map(x => [x, {}]).fromPairs().value(),
            bottom: _.chain(this.fields.bottom).map(x => [x, {}]).fromPairs().value(),
        };

        // preparing UI:
        for (let pc of this.prodConf.uilist) {
            if (!this.hasUiPlace(pc)) {
                continue;
            }

            let place = this.ui[pc.ui_row][pc.ui_place];
            place.push(pc);
            place.sort(pc => !pc.default);  // default first
        }
        for (let n of this.ticket.nutrients) {
            if (!this.hasUiPlace(n.config)) {
                continue;
            }

            let place = this.ui[n.config.ui_row][n.config.ui_place];
            let config = place.find(c => c.id === n.config.id);
            if (!config) {
                place.unshift(n.config);
            }
        }

        // default values:

        for (let pc of this.prodConf.uilist) {
            if (!this.hasUiPlace(pc)) {
                continue;
            }

            let place = this.values[pc.ui_row][pc.ui_place];
            place.percent = 0;
            place.lbs = 0;
            place.pc = this.ui[pc.ui_row][pc.ui_place][0];
        }

        // fill with real value


        for (let n of this.ticket.nutrients) {
            if (!this.hasUiPlace(n.config)) {
                continue;
            }

            let place = this.values[n.config.ui_row][n.config.ui_place];
            place.percent = n.percent;
            place.pc = this.ui[n.config.ui_row][n.config.ui_place].find(c => c.id === n.config.id);
        }

        this.calcLbs();

        /*
        ui = {
            top : {
               8: [pc1, pc2, pc3]
            }
        }
        values = {
            top: {
              8: {
                'pc': pc1,
                'percent': x
              }
            }
        }
         */
    }

    setClay(pct) {
        let self = this;
        let nutrients = [..._.values(self.values.top), ..._.values(self.values.bottom)];
        let clay = nutrients.find(x => x.pc && x.pc.source_of.id == 'clay');
        if (clay) {
            clay.percent = pct;
        }
    }

    calcLbs() {
        let self = this;
        for (let n of self.ticket.nutrients) {
            if (!this.hasUiPlace(n.config)) {
                continue;
            }

            let place = self.values[n.config.ui_row][n.config.ui_place];
            self.onPercentChanged(place);
        }
    }

    syncNutrientsToTicket() {
        let self = this;
        let topNutrients = _.values(self.values.top).filter(x => x.pc);
        let bottomNutrients = _.values(self.values.bottom).filter(x => x.pc);
        let nutrients = [...topNutrients, ...bottomNutrients];
        self.errorMapping = _.extend(
            {},
            _.fromPairs(topNutrients.map((_, i) => [i, `top_${i}`])),
            _.fromPairs(bottomNutrients.map((_, i) => [topNutrients.length + i, `bottom_${i}`])),
        );
        self.ticket.nutrients = nutrients.map(function (n) {
            return {
                percent: n.percent || 0,
                config: {
                    id: n.pc.id,
                },
            };
        });
    }

    handleErrors(errors) {
        errors = _.clone(errors);
        // take errors and their position in array:
        let nerrors = (errors.nutrients || []).map((err, i) => [i, err]);
        // filter out the empty ones
        nerrors = nerrors.filter(x => !_.isEmpty(x[1]));
        // take possition from errorMapping:
        nerrors = nerrors.map(([i, err]) => [this.errorMapping[i], _.values(err)[0]]);
        errors.nutrients = _.fromPairs(nerrors);
        return errors;
    }

    onPercentChanged(obj) {
        if (!obj.percent) {
            obj.percent = 0;
        }
        obj.percent = parseFloat(obj.percent);
        if (obj.percent < 0 || obj.percent > 100) {
            obj.percent = 0
        }
        obj.percent = _.round(obj.percent, 3);
        obj.lbs = this.ticket.rate * (obj.percent / 100);
        obj.lbs = _.round(obj.lbs, 3);
    }

    onLbsChanged(obj) {
        if (!obj.lbs) {
            obj.lbs = 0;
        }
        obj.lbs = parseFloat(obj.lbs);
        if (obj.lbs < 0) {
            obj.lbs = 0
        }
        obj.lbs = _.round(obj.lbs, 3);
        obj.percent = (obj.lbs / this.ticket.rate) * 100;
        obj.percent = _.round(obj.percent, 3);
    }
}


export class TicketRecalc extends BaseReCalc {
    constructor(ticket, fieldConf) {
        super(ticket);

        this.fieldConf = fieldConf;
    }

    _nutrients() {
        this.fieldConf.calcLbs();
    }
}

export class ListCtrl {
    constructor($growl, $state, Modal, TicketStore, Config) {
        "ngInject";
        this.$growl = $growl;
        this.$state = $state;
        this.Modal = Modal;
        this.store = TicketStore;
        this.Config = Config;
    }

    get showAngularCreateButton() {
        return !(
            this.Config.isFeatureFlagActive('REACT_TICKETS_LIST') &&
            this.$state.current.name === 'r.in.top.tickets.list.main'
        );
    }

    openAddModal() {
        let self = this;
        let $modal = this.Modal.open({
            template: addTpl,
            controller: AddTicketCtrl,
            size: 'small',
            resolve: {
                store: () => this.store,
            },
        });

        $modal.result.then(function (data) {
            self.$growl.added();
            self.$state.go(
                'r.in.top.tickets.detail',
                {ticketId: data.id, created: true},
                {absolute: true, reload: true}
            );
        });
    }
}

class CloneMixCtrl {
    constructor($uibModalInstance, ticket) {
        "ngInject";
        let self = this;

        self.$modal = $uibModalInstance;
        self.ticket = ticket;
        self.ticketList = [];
        self.endpoint = self.ticket.one('copy_mix');
        self.endpoint.getList().then(function (response) {
            self.ticketList = response;
        });
    }

    get title() {
        return `Clone Mix`;
    }

    close() {
        this.$modal.dismiss();
    }

    submit() {
        let self = this;
        self.loading = true;
        self.endpoint.post().then(() => {
            self.$modal.close({});
        }).finally(() => {
            self.loading = false;
        });
    }
}

export class DetailsCtrl {
    constructor(BB, SecureUrlService, $state, $growl, $company, $ticket, Modal, $interval, UserService) {
        "ngInject";
        this.BB = BB;
        this.ticket = $ticket;
        this.delivery_start = this.ticket.delivery_start
        this.delivery_stop = this.ticket.delivery_stop
        this.application_start = this.ticket.application_start
        this.application_stop = this.ticket.application_stop
        delete this.ticket.delivery_start;
        delete this.ticket.delivery_stop;
        delete this.ticket.application_start;
        delete this.ticket.application_stop;
        this.company = $company;
        this.$growl = $growl;
        this.$state = $state;
        this.Modal = Modal;
        this.secureUrlService = SecureUrlService;
        this.stopInterval = null;
        this.$interval = $interval;
        this.initDeliveryTimer();
        this.initApplicationTimer();
        this.user = UserService.$user;
    }

    onDestroy() {
        if (this.stopInterval) {
            clearInterval(this.stopInterval);
        }
    }

    sendToBB() {
        let self = this;
        let $modal = this.Modal.open({
            template: sendBBTpl,
            controller: SendPresetsCtrl,
            resolve: {
                company: () => this.company,
                ticket: () => this.ticket,
            },
        });

        $modal.result.then(function () {
            self.$state.go(self.$state.current, {created: false}, {reload: true});
        })
    }

    shippingTicketUrl() {
        let self = this;
        this.secureUrlService.openInNewWindow(self.ticket.one('shipping_ticket'));
    }

    get canCopyMix() {
        return this.ticket.order;
    }

    copyMix() {
        let self = this;
        let $modal = this.Modal.open({
            template: copyMixTpl,
            controller: CloneMixCtrl,
            resolve: {
                ticket: () => this.ticket,
            },
        });

        $modal.result.then(function () {
            self.$growl.success('Copied sucesfully');
        });
    }

    cloneTicket() {
        let self = this;
        let $modal = this.Modal.open({
            template: cloneTicketTpl,
            controller: CloneTicketCtrl,
            size: 'small',
            resolve: {
                ticket: () => this.ticket,
            },
        });

        $modal.result.then(function (data) {
            self.$state.go(
                'r.in.top.tickets.detail',
                {ticketId: data.id, created: true},
            );
            self.$growl.copied();
        });
    }

    print() {
        let self = this;
        let $modal = this.Modal.open({
            template: printModalTpl,
            controller: PrinterListModalCtrl,
            size: 'large',
            resolve: {
                company: () => self.ticket.company.id,
                request: () => {
                    return {
                        endpoint: self.ticket.all('shipping-ticket').all('print'),
                        multiple: false
                    }
                },
            }
        });

        $modal.result.then(function () {
            self.$state.go(self.$state.current, {created: false}, {reload: true});
            self.$growl.success('Added file to queue');
        });
    }

    getTimerModal(modalTpl) {
        return this.Modal.open({
            template: modalTpl,
            controller: ConfirmEditModalCtrl,
        });
    }

    confirmStopDeliveryModal() {
        let modal = this.getTimerModal(confirmStopDeliveryTpl)
        modal.result.then(() => {
            this.delivery_stop = this.saveTime(timerFields.deliveryStop, 'Delivery stopped!');
            this.stopTimer();
        });
    }

    confirmStopApplicationModal() {
        let modal = this.getTimerModal(confirmStopApplicationTpl)
        modal.result.then(() => {
            this.application_stop = this.saveTime(timerFields.applicationStop, 'Application stopped!');
            this.stopTimer();
        });
    }

    initDeliveryTimer() {
        if (this.delivery_start && !this.delivery_stop && !this.ticket.break_in_progress) {
            this.displayDeliveryTime = this.calcDatetimeDiff(new Date(), Date.parse(this.delivery_start), this.ticket.break_time);
            this.stopInterval = this.startTimer(timerType.delivery)
        } else if (this.delivery_start && !this.delivery_stop && this.ticket.break_in_progress) {
            this.displayDeliveryTime = this.calcDatetimeDiff(new Date(), Date.parse(this.delivery_start), this.ticket.break_time);
        }
    }

    initApplicationTimer() {
        if (this.application_start && !this.application_stop && !this.ticket.break_in_progress) {
            this.displayApplicationTime = this.calcDatetimeDiff(new Date(), Date.parse(this.application_start), this.ticket.break_time);
            this.stopInterval = this.startTimer(timerType.application);
        } else if (this.application_start && !this.application_stop && this.ticket.break_in_progress) {
            this.displayApplicationTime = this.calcDatetimeDiff(new Date(), Date.parse(this.application_start), this.ticket.break_time);
        }
    }

    startTimer(type) {
        if (type === timerType.delivery) {
            return this.$interval(() => {
                this.displayDeliveryTime = this.calcDatetimeDiff(new Date(), Date.parse(this.delivery_start), this.ticket.break_time);
            }, 1000);
        } else if (type === timerType.application) {
            return this.$interval(() => {
                this.displayApplicationTime = this.calcDatetimeDiff(new Date(), Date.parse(this.application_start), this.ticket.break_time);
            }, 1000);
        }

    }

    stopTimer() {
        this.$interval.cancel(this.stopInterval);
    }

    calcDatetimeDiff(toTime, fromTime, break_time = 0) {
        const newDateDiff = (toTime - fromTime) / 1000 - break_time;
        return this.transform(newDateDiff);
    }

    transform(value) {
        const sec_num = Math.floor(value);
        let hours = Math.floor(sec_num / 3600);
        let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        const seconds = sec_num - (hours * 3600) - (minutes * 60);
        return hours + 'h : ' + minutes + 'm : ' + seconds + 's';
    }

    saveTime(field, message) {
        const new_datetime = new Date();
        this.ticket.patch({[field]: new_datetime}).then(
            (response) => {
                angular.extend(this.ticket, response);
                this.$growl.success(message);
            },
            (response) => {
                if (response.status === 500) {
                    this.$growl.error(response.data.detail);
                }
            }
        );
        return new_datetime
    }

    showInDelivery() {
        return this.delivery_start && !this.delivery_stop;
    }

    showInApplication() {
        return this.application_start && !this.application_stop;
    }

    showStopDelivery() {
        return this.delivery_start && !this.delivery_stop && (this.user.role.name === 'Admin' || this.user.role.name === 'Dispatcher');
    }

    showStopApplication() {
        return this.application_start && !this.application_stop && (this.user.role.name === 'Admin' || this.user.role.name === 'Dispatcher');
    }
}

export class ConfirmDeliveryModalCtrl {
    constructor($uibModalInstance) {
        "ngInject";
        this.$modal = $uibModalInstance;
    }

    confirmChange() {
        this.$modal.close();
    }

    cancel() {
        this.$modal.dismiss();
    }
}

class CloneTicketCtrl {
    constructor($state, $uibModalInstance, R, ticket) {
        "ngInject";
        this.ticket = ticket;
        delete this.ticket.delivery_start;
        delete this.ticket.delivery_stop;
        delete this.ticket.application_start;
        delete this.ticket.application_stop;
        this.$modal = $uibModalInstance;
        this.$state = $state;
        this.data = R.copy(this.ticket);
    }

    get title() {
        return `Copy ticket`;
    }

    close() {
        this.$modal.dismiss();
    }

    submit() {
        let self = this;
        let copyNotes = false;
        self.loading = true;
        const copyNotesCheck = document.getElementById("copy-notes")
        if (copyNotesCheck) {
            copyNotes = copyNotesCheck.checked
        }

        self.ticket
            .one("clone")
            .customPOST({customer: self.data.customer, copy_notes: copyNotes})
            .then(
                (response) => {
                    self.$modal.close(response);
                },
                (resp) => {
                    self.errors = resp.data;
                }
            )
            .finally(() => (self.loading = false));
    }
}

export class ConfirmEditModalCtrl {
    constructor($uibModalInstance) {
        "ngInject";
        this.$modal = $uibModalInstance;
    }

    edit() {
        this.$modal.close();
    }

    cancel() {
        this.$modal.dismiss();
    }
}

export class ConfirmSendModalCtrl {
    constructor($uibModalInstance) {
        "ngInject";
        this.$modal = $uibModalInstance;
    }

    send() {
        this.$modal.close();
    }

    cancel() {
        this.$modal.dismiss();
    }
}


export class TicketDetailsCtrl extends DetailViewMap {
    constructor($ticket, $company, $growl, $stateParams, $prodConf, $state, hotkeys, modalRegistry, Modal) {
        "ngInject";
        super($ticket); // maps
        this.$state = $state;
        this.$growl = $growl;
        this.$stateParams = $stateParams;
        this.ticket = $ticket;
        delete this.ticket.delivery_start;
        delete this.ticket.delivery_stop;
        delete this.ticket.application_start;
        delete this.ticket.application_stop;
        this.hotkeys = hotkeys;
        this.modalRegistry = modalRegistry;
        this.prodConf = $prodConf;
        this.company = $company;
        this.fieldConf = null;
        this.tRecalc = null;
        this.state = {};
        this.Modal = Modal;
        this.onEdit = () => this.requestOpenEditModal();
        this.setFieldConf();
        this.setHotKeys();
        this.customEvents();
    }

    customEvents() {
        if (this.$stateParams.created) {
            this.openEditModal();
        }
    }

    setHotKeys() {
        let self = this;
        self.hotkeys.add({
            combo: 'e',
            description: 'Edit Modal',
            callback: function (event, hotkey) {
                if (self.modalRegistry.isOpen('ticket-edit')) {
                    return
                }
                ;
                self.modalRegistry.push('ticket-edit');
                self.requestOpenEditModal();
            }
        });
    }

    setFieldConf() {
        this.fieldConf = new FieldConf(this.ticket, this.prodConf);
        this.tRecalc = new TicketRecalc(this.ticket, this.fieldConf);
    }

    openEditModal() {
        let self = this;
        let modal = this.Modal.open({
            template: ticketEditTpl,
            controller: TicketEditModalCtrl,
            size: 'ticket-edit',
            resolve: {
                ticket: () => this.ticket,
                prodConf: () => this.prodConf,
                company: () => this.company,
                state: () => this.state,
            },
        });

        modal.result.then(function (r) {
            if (r && r.companyChanged) {
                self.$growl.success('You\'ve changed company! New ticket number generated!');
                self.$state.go(
                    'r.in.top.tickets.detail',
                    {ticketId: r.newId, created: false},
                    {absolute: true}
                )
            }
            if (self.$stateParams.created) {
                // reload page if crated
                window.location.reload()
            } else {
                // Update components
                self.setFieldConf();
                self.getStaticLocations();
                self.updateMarkers();
            }
        }).finally(() => {
            self.modalRegistry.pop('ticket-edit');
        })
    }

    requestOpenEditModal() {
        let self = this;
        if (this.ticket.status === ticketStatus.completed) {
            let modal = self.Modal.open({
                template: ticketConfirmEditTpl,
                controller: ConfirmEditModalCtrl,
            });
            modal.result.then(() => self.openEditModal());
        } else {
            this.openEditModal();
        }
    }
}

export class TicketEditModalCtrl extends EditViewMap {
    constructor(R, $growl, $location, $timeout, $uibModalInstance, ticket, prodConf, company, state) {
        "ngInject";
        super(ticket);
        this.$growl = $growl;
        this.$modal = $uibModalInstance;
        this.$timeout = $timeout;
        this.company = company;
        this.ticket = ticket;
        delete this.ticket.delivery_start;
        delete this.ticket.delivery_stop;
        delete this.ticket.application_start;
        delete this.ticket.application_stop;

        this.R = R;
        this.data = R.copy(this.ticket);
        this.fieldConf = new FieldConf(this.data, prodConf);
        this.tRecalc = new TicketRecalc(this.data, this.fieldConf);
        this.loading = {};
        this.state = state;
        this.acresStatus = '';
        this.saveDisabled = false;
        this.companyChanged = false;

        if (this.company.custom_delay !== null && this.data.delay === null) {
            this.data.delay = this.company.custom_delay;
        }

        $location.hash(''); // clear
    }

    onCompanyChange() {
    }

    onCustomerChange() {
        this.data.freight_zone = this.data.customer.freight_zone
    }

    get isZoneEditable() {
        return this.data.company.id === MARION_ID;
    }

    onAcresModelChange() {
        this.tRecalc.acres();
        this.data.is_acres_touched = true;
    }

    onQuantityChange() {
        this.tRecalc.quantity();
        this.data.is_acres_touched = true;
    }

    handleFormulationErrors(errors) {
        this.saveDisabled = true;
        this.calc('calc', false);
    }

    handleErrors(errors) {
        if (errors.formulation) {
            this.handleFormulationErrors(errors)
        }
        this.errors = this.fieldConf.handleErrors(errors);
    }

    acresStatusCallback() {
        this.acresStatus = '';
    }

    reCalculateAcres(canReCalc) {
        if (canReCalc) {
            return
        }
        this.data.acres = _.round(_.sum(_.map(this.data.fields, 'field.acres')), 2);
        this.tRecalc.acres();
    }

    onAcresTouchChange(isChanged) {
        this.reCalculateAcres(isChanged);
    }

    onAcresChange(action) {
        if (this.data.is_acres_touched) {
            this.acresStatus = 'not-updated';
        } else {
            this.acresStatus = 'updated';
        }

        this.reCalculateAcres(this.data.is_acres_touched);
        this.getDynamicLocations(this.data.fields)
        this.updateMarkers();
    }

    getData() {
        let data = angular.copy(this.data);

        delete data.delivery_start;
        delete data.delivery_stop;
        delete data.application_start;
        delete data.application_stop;
        delete this.data.delivery_start;
        delete this.data.delivery_stop;
        delete this.data.application_start;
        delete this.data.application_stop;
        data.products = _.filter(data.products, (o) => {
            return o.product;
        }); // to avoid glitches
        return data;
    }

    beforeSend() {
        let self = this;
        self.data.gals = self.data.gals === '' ? null : self.data.gals;
        self.data.lbs_gal = self.data.lbs_gal === '' ? null : self.data.lbs_gal;
        self.data.custom_fields_destinations = self.ticket.custom_fields_destinations;

        if (self.data.applicators == null) {
            self.data.applicators = []
        } else if (!Array.isArray(self.data.applicators)) {
            self.data.applicators = Array(self.data.applicators)
        }
        if (self.data.haulers == null) {
            self.data.haulers = []
        } else if (!Array.isArray(self.data.haulers)) {
            self.data.haulers = Array(self.data.haulers)
        }
    }

    calc(btn, raise_exception = true) {
        let self = this;
        let params = {};
        btn = btn || 'calc';
        self.loading[btn] = true;
        self.errors = {};
        self.fieldConf.syncNutrientsToTicket();

        if (btn === 'calc_clay') {
            params.calc_clay = 1;
        }
        params.raise = raise_exception;
        self.beforeSend();
        let data = self.getData();
        self.data.one('calc').customPUT(data, null, params).then(
            function (response) {
                if (btn === 'calc_clay') {
                    self.fieldConf.setClay(response.formulation.clay || 0);
                } else {
                    let newData = response.plain();
                    delete newData.products; // Do not remove last line if cals
                    angular.extend(self.data, newData);
                }
                if (raise_exception) {
                    self.saveDisabled = false;
                }
            },
            function (response) {
                if (response.status === 500) {
                    self.$growl.error("Server Error. We could not calculate formula!");
                    return;
                }
                self.handleErrors(response.data);
            },
        ).finally(() => self.loading = {});
    }

    submit(close = true) {
        let self = this;
        if (self._submitting) { return; }
        self._submitting = true;
        let params = {};

        self.loading[close ? 'submit' : 'submitc'] = true;
        self.fieldConf.syncNutrientsToTicket();
        self.errors = {};
        let data = self.getData();
        delete data.delivery_start;
        delete data.delivery_stop;

        data.products = 'a';
        self.beforeSend();
        data.put(params).then(
            function (response) {
                angular.extend(self.ticket, response);
                if (close) {
                    let changed = !angular.equals(self.ticket.company, self.data.company);
                    angular.extend(self.ticket, response);
                    self.$growl.updated();
                    self.$modal.close({companyChanged: changed, newId: response.id});
                }
            },
            function (resp) {
                if (resp.status === 500) {
                    self.$growl.error("Server Error. We could not calculate formula!");
                    return;
                } else if (resp.status === 400) {
                    Object.entries(resp.data).forEach(entry => {
                        const [field, error] = entry
                        error.forEach(err_msg => {
                            if (typeof err_msg === 'object' && err_msg !== null) {
                                Object.entries(err_msg).forEach(list_entry => {
                                    self.$growl.error(`${field}: ${list_entry}`)
                                })
                            } else {
                                self.$growl.error(`${field}: ${err_msg}`)
                            }
                        })
                    })
                }
                self.handleErrors(resp.data);
            },
        ).finally(() => {
            self.loading = {};
            self._submitting = false;
        });
    }

    close() {
        this.$modal.close();
    }

}


export class TicketLogCtrl {
    constructor($ticket) {
        "ngInject";
        this.ticket = $ticket;
    }
}

class AddTicketCtrl extends BaseAddModal {

    constructor($uibModalInstance, store, UserService) {
        "ngInject";
        super($uibModalInstance, store, UserService);
    }

    get title() {
        return 'Add Ticket';
    }
}


class SendPresetsCtrl {
    constructor(BB, $uibModalInstance, company, ticket, $growl, Modal) {
        "ngInject";
        let self = this;

        self.$modal = $uibModalInstance;
        self.$growl = $growl;
        self.ticket = ticket;
        self.company = company;
        self.BB = BB;
        self.loading = false;
        self.checking = false;
        self.ctrl = BB.ctrl;
        self.presets = {};
        self.Modal = Modal;
        self.registerTags = _.uniq([
            self.company.murray_settings.chem_write_tag,
            self.company.murray_settings.fert_write_tag,
        ]);

        self.checkStatus();
        self.getPresets();

        self.checkingIfBusyPromise = null;
    }

    checkStatus() {
        let self = this;
        self.checking = true;
        return self.BB.status(self.registerTags).finally(() => {
            self.checking = false;
        });
    }

    getPresets() {
        let self = this;
        self.ticket.one('murray').get().then(function (response) {
            angular.extend(self.presets, response);
        })
    }

    beforeSubmit() {
        let self = this;
        if (this.ticket.status === ticketStatus.completed) {
            let modal = this.Modal.open({
                template: ticketConfirmSendTpl,
                controller: ConfirmSendModalCtrl,
            });
            modal.result.then(() => self.submit());
        } else {
            self.submit();
        }
    }

    submit() {
        let self = this;
        let presets = [].concat.apply([], _.values(self.presets.plain()));
        presets = presets.map(x => _.pick(x, ['write_tag', 'preset_code', 'preset']));

        self.loading = true;
        self.BB.sendPresets(self.registerTags, presets).then(
            function () {
                self.presets.put().finally(function () {
                    self.$growl.growl.success("Presets sent");
                    self.$modal.close();
                })
            },
        ).finally(() => {
            self.loading = false;
        });
    }

    close() {
        this.$modal.dismiss();
    }

}


export class FilesCtrl {
    constructor($ticket) {
        "ngInject";
        this.ticket = $ticket;
    }
}

export class TicketShippingCtrl {
    constructor(R, $growl, $timeout, $ticket) {
        "ngInject";
        this.$growl = $growl;
        this.$timeout = $timeout;
        this.ticket = $ticket;
        delete this.ticket.delivery_start;
        delete this.ticket.delivery_stop;
        delete this.ticket.application_start;
        delete this.ticket.application_stop;
        this.R = R;
        this.data = R.copy(this.ticket);
        this.loading = {};
        this.acresStatus = '';
        this.saveDisabled = false;
        this.companyChanged = false;
        this.nozzle_sizes = Array.from({length: 21}, (x, i) => i * 5 + 25);  // [25, 30, ... ,125]
        this.speeds = Array.from({length: 21}, (x, i) => i);  // [0, 1, 2, ... , 19, 29]
        this.temps = Array.from({length: 86}, (x, i) => i + 20);  // [20, 21, ... , 104, 105]
        this.directions = ["N", "NE", "E", "SE", "S", "SW", "W", "NW"];
        const wind = this.data.applicators_notes.wind;
        this.data.applicators_notes.wind = wind ? "Yes" : "No";
    }

    getData() {
        let data = angular.copy(this.data);
        const wind = data.applicators_notes.wind;
        data.applicators_notes.wind = wind === "Yes";
        return data;
    }

    submit() {
        let self = this;
        self.errors = {};
        let data = self.getData();
        self.ticket.customPATCH({applicators_notes: data.applicators_notes}).then((response) => {
            angular.extend(self.ticket, response);
        }, (resp) => {
            self.errors = resp.data;
        });
    }
}

export class TicketNotesCtrl {
    constructor(R, $growl, $timeout, $ticket) {
        "ngInject";
        this.$growl = $growl;
        this.$timeout = $timeout;
        this.ticket = $ticket;
        delete this.ticket.delivery_start;
        delete this.ticket.delivery_stop;
        delete this.ticket.application_start;
        delete this.ticket.application_stop;
        this.R = R;
        this.data = R.copy(this.ticket);
    }

    submit() {
        let self = this;
        self.errors = {};
        self.ticket.customPATCH({notes: self.data.notes}).then((response) => {
            angular.extend(self.ticket, response);
        }, (resp) => {
            self.errors = resp.data;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/tickets/ctrls.js